import disneyOneIdWrapper from 'disneyOneIdWrapper'; //eslint-disable-line import/no-unresolved, import/extensions
import { copyProps, convertGender, letterCase } from './utils';

export default function (contextData) {
    let acquiredDisneyInfo;
    return new Promise((resolve) => {
        disneyOneIdWrapper.init().then((res) => {
            acquiredDisneyInfo = {};
            try {
                if (res && res.loggedIn) {
                    acquiredDisneyInfo.registrationtype = 'espn';

                    const guest = res.guest;
                    if (guest) {

                        const profile = guest.profile;
                        if (profile) {
                            acquiredDisneyInfo.loginstatus = `Registered:Logged in ${letterCase(profile.status)}`;

                            if (profile.swid) {
                                acquiredDisneyInfo.swid = guest.profile.swid;
                            }

                            if (profile.gender) {
                                acquiredDisneyInfo.gender = convertGender(profile.gender);
                            }

                            if (profile.dateOfBirth) {
                                acquiredDisneyInfo.birthage = (profile.dateOfBirth || '').slice(0, 4);
                            }
                        }

                    }
                }
            } catch (err) {
                console.error(err);
            }

            copyProps(acquiredDisneyInfo, contextData);

            resolve();
        }).catch((err) => {
            console.error('Error gathering OneId async analytics props', err);
            resolve();
        });
    }).catch((err) => {
        // ignore errors and continue on...
        console.warn('Error accessing Disney OneId props', err);
    });
}

